import React, { ReactElement, SetStateAction } from 'react';
import { ITimesheetsJobToInvoice } from '../types';
import TimesheetReportGlobalBodyRow from './Row';
import { ITimesheetsReportGlobalPrint } from '@jobcost-monorepo/utils';

interface IProps {
  data: ITimesheetsReportGlobalPrint[];
  startDate: string;
  setGroupedData: React.Dispatch<
    React.SetStateAction<ITimesheetsReportGlobalPrint[]>
  >;
  endDate: string;
  setInvoiceFormOpen: (
    value: SetStateAction<ITimesheetsJobToInvoice | undefined>,
  ) => void;
}
const TimesheetReportGlobalBody = React.forwardRef<HTMLDivElement, IProps>(
  (
    { data, startDate, endDate, setInvoiceFormOpen, setGroupedData },
    ref,
  ): ReactElement => {
    if (startDate === undefined || endDate === undefined) {
      return <div />;
    }

    return (
      <div ref={ref} className="overflow-y-auto">
        {data.map((row, index) => (
          <TimesheetReportGlobalBodyRow
            groupedData={data}
            setGroupedData={setGroupedData}
            key={`timesheetReportGlobalBodyRow-${index}`}
            data={row}
            startDate={startDate}
            endDate={endDate}
            setInvoiceFormOpen={setInvoiceFormOpen}
          />
        ))}
      </div>
    );
  },
);

TimesheetReportGlobalBody.displayName = 'TimesheetReportGlobalBody';

export default TimesheetReportGlobalBody;
